if (!window.__productDescriptionToggleBound) {
  window.__productDescriptionToggleBound = true;

  class ProductDescriptionToggle {
    constructor(container) {
      this.container = container;
      this.content = container.querySelector('.product__description-content');
      if (!this.content) return;
      this.isOverflowing = null;

      this.button = container.parentElement.querySelector(
        '[data-description-toggle][aria-controls="' + this.content.id + '"]'
      );
      if (!this.button) return;

      this.onToggle = this.onToggle.bind(this);
      this.update = this.update.bind(this);

      this.button.addEventListener('click', this.onToggle);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.content);
      } else {
        window.addEventListener('resize', this.update);
      }

      this.update();
    }

    setExpanded(expanded) {
      this.container.dataset.descriptionCollapsed = expanded ? 'false' : 'true';
      this.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      const moreLabel = this.button.querySelector('[data-description-label-more]');
      const lessLabel = this.button.querySelector('[data-description-label-less]');

      if (moreLabel) moreLabel.classList.toggle('hidden', expanded);
      if (lessLabel) lessLabel.classList.toggle('hidden', !expanded);
    }

    update() {
      const wasExpanded = this.button.getAttribute('aria-expanded') === 'true';
      const isOverflowing =
        wasExpanded && this.isOverflowing !== null
          ? this.isOverflowing
          : this.content.scrollHeight > this.content.clientHeight + 1;

      this.isOverflowing = isOverflowing;
      this.button.classList.toggle('hidden', !isOverflowing);

      if (!isOverflowing) {
        this.setExpanded(false);
        return;
      }

      this.setExpanded(wasExpanded);
    }

    onToggle() {
      const expanded = this.button.getAttribute('aria-expanded') === 'true';
      this.setExpanded(!expanded);
    }
  }

  const initProductDescriptionToggles = (root) => {
    root.querySelectorAll('[data-description-block]').forEach((container) => {
      if (container.__productDescriptionToggle) return;
      container.__productDescriptionToggle = new ProductDescriptionToggle(container);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initProductDescriptionToggles(document));
  document.addEventListener('shopify:section:load', (event) => initProductDescriptionToggles(event.target));
}
